module.exports = __webpack_public_path__ + "assets/img/banner20.b364d175.jpg";